import React from 'react'
import './SksProductTitle.scss'

/*
  Шапка секции во всю ширину: заголовок, лид и кнопка. Лид раньше был
  вторым h1 в правой колонке — из-за этого первый пункт списка вставал
  рядом с заголовком и сетка выглядела сломанной.
*/
const SksProductTitle = ({ setModal }) => {
  return (
    <div className="sksProductTitle_content">
      <h1>Возможности</h1>
      <p className="sksProductTitle_lead">
        Оставьте свой номер — обсудим ваши задачи и пути решения, рассчитаем стоимость
      </p>
      <button
        type="button"
        className="sksProductTitle_btn"
        onClick={() => setModal(true)}
      >
        Получить консультацию <span aria-hidden="true">→</span>
      </button>
    </div>
  )
}

export default SksProductTitle
